import { DifferenceEntry } from "slot-definitions"

export function AuthoringReviewMovementsEntry({ component }) {
    if (!component?.type) return null

    const { type: Type, props } = component

    return (
        <DifferenceEntry.Slot>
            <Type {...props} />
        </DifferenceEntry.Slot>
    )
}
